import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  description: {
    marginTop: 8,
  },
}));

export default useStyles;
